import { getAllowedBrands } from '@anm/helpers/branding';
import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { fetchBrandsAsync, updateCurrentBrandId } from '../actions';
import { BrandActions, BrandState } from '../types';

import { initialBrandState } from '.';

const fetchBrandsReducer: Reducer<BrandState, BrandActions> = (
  state = initialBrandState,
  action
) => {
  switch (action.type) {
    case getType(fetchBrandsAsync.request): {
      return {
        ...state,
        brandsList: {
          ...state.brandsList,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(fetchBrandsAsync.success): {
      const brandList = getAllowedBrands(action.payload);
      return {
        ...state,
        brandsList: {
          ...state.brandsList,
          data: brandList,
          currentBrandId: brandList[0].id,
          isPending: false
        }
      };
    }
    case getType(fetchBrandsAsync.failure): {
      return {
        ...state,
        brandsList: {
          ...state.brandsList,
          isError: true,
          isPending: false,
          error: action.payload
        }
      };
    }
    case getType(updateCurrentBrandId): {
      return {
        ...state,
        brandsList: {
          ...state.brandsList,
          currentBrandId: action.payload
        }
      };
    }
    default:
      return state;
  }
};

export default fetchBrandsReducer;
